import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
export default function DashboardTab({
  value,
  handleChange,
  labels,
  children,
  justifyContent,
  width,
  minWidth
}) {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#FAFAFA',
      '& .MuiTabs-flexContainer': {
        justifyContent: justifyContent ? justifyContent : 'center',
        alignItems: 'center',
        height: '50px',
        padding: '0 5px'
      },
      '& .MuiAppBar-root': {
        background: ' #F2F2F2',
        border: '1.02058px solid #E1E1E1',
        boxShadow: 'inset -4px 5px 8px rgba(237, 237, 237, 0.37)',
        borderRadius: '32.6585px',
        display: 'inline-block',
        width: width ? width : '100%',
        height: '50px'
      },
      '& .MuiTab-root': {
        minHeight: '40px',
        minWidth: minWidth ? minWidth : '160px'
      },
      '& .MuiTabs-root': {
        minHeight: '50px'
      },
      '& .MuiTabs-indicator': {
        display: 'none'
      },
      '& .Mui-selected': {
        background: '#FFFFFF',
        boxShadow: '0px 2px 4px rgba(96, 97, 112, 0.16)',
        borderRadius: '40.8231px',
        padding: '0 15px'
      },
      '& .MuiTab-textColorInherit ': {
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '192.86%',
        color: '#545454',
        padding: '0 15px'
      },
      '& .MuiTab-textColorInherit.Mui-selected': {
        color: '#171717'
      },
      '& .MuiTabs-scrollable': {
        overflowX: 'auto',
        whiteSpace: 'nowrap'
      }
    }
  }));
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar position='static'>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='simple tabs example'
          variant='scrollable'
          scrollButtons='auto'
        >
          {labels?.map((label, index) => (
            <Tab
              label={label}
              {...a11yProps(index)}
              id={`other-actions-${index + 1}`}
            />
          ))}
        </Tabs>
      </AppBar>
      {children}
    </div>
  );
}
